import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({ selector: '[vectronicPhoneFormat]', standalone: true })
export class PhoneFormatDirective {
  private el = inject<ElementRef<HTMLInputElement>>(ElementRef);
  private ngControl = inject(NgControl);

  @HostListener('input')
  onInput(): void {
    const value = this.el.nativeElement.value;
    const cursorStart = this.el.nativeElement.selectionStart;

    let transformedValue = value;
    let cursorOffset = 0;

    if (value.startsWith('00')) {
      transformedValue = '+' + value.slice(2);
      cursorOffset = 1;
    }

    this.ngControl.control?.setValue(transformedValue);

    if (cursorStart) {
      const newCursorPos = cursorStart - cursorOffset;
      this.el.nativeElement.setSelectionRange(newCursorPos, newCursorPos);
    }
  }
}
